import { SolanaAdapter } from "@reown/appkit-adapter-solana";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { AppKitNetwork, avalanche, solana } from "@reown/appkit/networks";
import { createAppKit } from "@reown/appkit/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import {
  PhantomWalletAdapter,
  SolflareWalletAdapter,
} from "@solana/wallet-adapter-wallets";
import { clusterApiUrl } from "@solana/web3.js";

const ProviderConnectWallet = ({ children }: any) => {
  const metadata = {
    name: "Kibble Avax",
    description: "Kibble Avax",
    url: "https://app.kibble.exchange/",
    icons: ["https://kibble.exchange/favicon.png"],
  };
  const projectId = "c84624b4b35e21d900b3f8f307122687";
  const queryClient = new QueryClient();
  const solanaAdapter: any = new SolanaAdapter() as any;
  const networks: [AppKitNetwork, ...AppKitNetwork[]] = [
    avalanche as AppKitNetwork,
    solana,
  ];
  const wagmiAdapter = new WagmiAdapter({
    networks,
    projectId,
  });
  createAppKit({
    adapters: [wagmiAdapter, solanaAdapter],
    networks,
    projectId,
    metadata,
    themeMode: "dark",
    features: {
      swaps: false,
      analytics: false,
      onramp: false,
      socials: false,
      emailShowWallets: false,
      email: false,
    },
  });

  const wallets = [new PhantomWalletAdapter(), new SolflareWalletAdapter()];

  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <ConnectionProvider endpoint={clusterApiUrl("mainnet-beta")}>
          <WalletProvider wallets={wallets} autoConnect>
            {children}
          </WalletProvider>
        </ConnectionProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default ProviderConnectWallet;
